/**
 * ALL FOUR seed builders — single point of truth (plan §0.3 · SC-Q8).
 *
 * | Stream            | Expression              |
 * |-------------------|-------------------------|
 * | Security scalars  | ticker + 'v3'           |
 * | Price series      | ticker + window + 's'   |
 * | Analyst consensus | ticker + 'a'            |
 * | Catalysts         | ticker + 'n'            |
 *
 * Omitting 'v3' silently regenerates the entire dataset (R1).
 * Export names: ADR-0009 / naming §3.3.
 *
 * ── A FIFTH STREAM EXISTS IN THE DEMO AND IS NOT PORTED HERE ──
 * The reference builds index sparklines (demos/Meridian Terminal.dc.html line
 * 889) from `rng(hash(indexCode + window))` — note NO suffix, unlike all four
 * builders above — iterating the three index codes at line 886, and walks them
 * with INDEX_SPARKLINE_SIGMA rather than the per-security vol.
 *
 * Whoever ports that walk MUST first settle one contract question: the demo
 * seeds with its own alternate Nasdaq spelling, which this codebase normalises
 * to NDX everywhere (index-sets.ts, index-membership.ts, and the vocabulary
 * gate). Seeding with the normalised spelling produces a DIFFERENT benchmark
 * curve than the demo — plausible, deterministic, and wrong in exactly the way
 * plan §0.3 R1 describes. Resolve it with an ADR before writing the builder;
 * do not infer the spelling from the surrounding normalised code.
 */
import type { WindowKey } from '@meridian/contracts';

/** Security scalars: price, vk, vol, beta, dev, ret[], dd[], factors. */
export function seedSecurityScalars(ticker: string): string {
  return ticker + 'v3';
}

/** Price series bars for (ticker, window). */
export function seedPriceSeries(ticker: string, window: WindowKey): string {
  return ticker + window + 's';
}

/** Analyst consensus stream. */
export function seedConsensus(ticker: string): string {
  return ticker + 'a';
}

/** Catalyst / news headline stream. */
export function seedCatalysts(ticker: string): string {
  return ticker + 'n';
}
